import { z } from 'zod';

export const questionSchema = z
  .object({
    key: z
      .string()
      .min(1, 'Key is required')
      .regex(
        /^[a-z][a-z0-9_]*$/,
        'Must start with letter, only lowercase, numbers, and underscores'
      ),
    label: z.string().min(1, 'Label is required'),
    placeholder: z.string().optional(),
    question_type: z.enum([
      'string',
      'radio',
      'text',
      'select',
      'multi_select',
    ]),
    required: z.boolean(),
    order: z.number().nullable().optional(),
    max_selections: z.number().nullable().optional(),
    options: z
      .array(
        z.object({
          label: z.string().min(1, 'Option label is required'),
          value: z.string().min(1, 'Option value is required'),
        })
      )
      .optional(),
    is_filterable: z.boolean().optional(),
    is_visible_to_mentors: z.boolean().optional(),
    filter_display_name: z
      .union([z.string(), z.null(), z.undefined()])
      .transform((val) => val || '')
      .optional(),
    can_be_filter: z.boolean().optional(),
  })
  .refine(
    (data) => {
      if (['radio', 'select', 'multi_select'].includes(data.question_type)) {
        return data.options && data.options.length > 0;
      }
      return true;
    },
    {
      message: 'Options are required for this question type',
      path: ['options'],
    }
  )
  .refine(
    (data) => {
      if (data.max_selections && data.question_type !== 'multi_select') {
        return false;
      }
      return true;
    },
    {
      message: 'Maximum selections can only be set for multi_select questions',
      path: ['max_selections'],
    }
  );

export type QuestionFormData = z.infer<typeof questionSchema>;
